import { SupplierEdit } from 'components/Suppliers/SupplierEdit';

export const CruiseEdit: React.FC = () => (
  <SupplierEdit isHotelSupplier={false} />
);
